export default {
  schema: {
    title: 'Dates Screen',
    type: 'object',
    additionalProperties: false,
    properties: {
      dtm_expsub: {
        type: 'string',
        title: 'Expected Month of Submission for Funding',
        $ref: '#/definitions/months-642419'
      },
      dtd_expsub: {
        type: 'integer',
        title: 'Expected Day of Submission for Funding',
        minimum: 1,
        maximum: 31
      },
      dty_expsub: {
        type: 'integer',
        title: 'Expected Year of Submission for Funding',
        minimum: 1900,
        maximum: 2100
      },
      dtm_sub: {
        type: 'string',
        title: 'Month Submitted for Funding',
        $ref: '#/definitions/months-642419'
      },
      dtd_sub: {
        type: 'integer',
        title: 'Day Submitted for Funding',
        minimum: 1,
        maximum: 31
      },
      dty_sub: {
        type: 'integer',
        title: 'Year Submitted for Funding',
        minimum: 1900,
        maximum: 2100
      },
      dtm_start: {
        type: 'string',
        title: 'Month',
        $ref: '#/definitions/months-642419'
      },
      dtd_start: {
        type: 'integer',
        title: 'Day',
        minimum: 1,
        maximum: 31
      },
      dty_start: {
        type: 'integer',
        title: 'Year',
        minimum: 1900,
        maximum: 2100
      },
      dtm_end: {
        type: 'string',
        title: 'Month',
        $ref: '#/definitions/months-642419'
      },
      dtd_end: {
        type: 'integer',
        title: 'Day',
        minimum: 1,
        maximum: 31
      },
      dty_end: {
        type: 'integer',
        title: 'Year',
        minimum: 1900,
        maximum: 2100
      }
    },
    definitions: {
      'months-642419': {
        enum: ['642420', '642421', '642422', '642423', '642424', '642425', '642426', '642427', '642428', '642429', '642430', '642431'],
        enumNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      }
    },
    allOf: [{
      anyOf: [{
        required: ['dty_expsub']
      }, {
        required: ['dty_sub']
      }, {
        required: ['dty_start']
      }, {
        required: ['dty_end']
      }]
    }, {
      allOf: [{
        if: {
          properties: {
            dtm_expsub: {
              enum: ['642423', '642425', '642428', '642430']
            }
          }
        },
        then: {
          properties: {
            dtd_expsub: {
              maximum: 30
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_expsub: {
                const: '642421'
              }
            }
          }, {
            oneOf: [{
              properties: {
                dty_expsub: {
                  multipleOf: 4,
                  not: {
                    multipleOf: 100
                  }
                }
              }
            }, {
              properties: {
                dty_expsub: {
                  multipleOf: 400
                }
              }
            }]
          }]
        },
        then: {
          properties: {
            dtd_expsub: {
              maximum: 29
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_expsub: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_expsub: {
                not: {
                  multipleOf: 4
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_expsub: {
              maximum: 28
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_expsub: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_expsub: {
                multipleOf: 100,
                not: {
                  multipleOf: 400
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_expsub: {
              maximum: 28
            }
          }
        }
      }]
    }, {
      allOf: [{
        if: {
          properties: {
            dtm_sub: {
              enum: ['642423', '642425', '642428', '642430']
            }
          }
        },
        then: {
          properties: {
            dtd_sub: {
              maximum: 30
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_sub: {
                const: '642421'
              }
            }
          }, {
            oneOf: [{
              properties: {
                dty_sub: {
                  multipleOf: 4,
                  not: {
                    multipleOf: 100
                  }
                }
              }
            }, {
              properties: {
                dty_sub: {
                  multipleOf: 400
                }
              }
            }]
          }]
        },
        then: {
          properties: {
            dtd_sub: {
              maximum: 29
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_sub: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_sub: {
                not: {
                  multipleOf: 4
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_sub: {
              maximum: 28
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_sub: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_sub: {
                multipleOf: 100,
                not: {
                  multipleOf: 400
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_sub: {
              maximum: 28
            }
          }
        }
      }]
    }, {
      allOf: [{
        if: {
          properties: {
            dtm_start: {
              enum: ['642423', '642425', '642428', '642430']
            }
          }
        },
        then: {
          properties: {
            dtd_start: {
              maximum: 30
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_start: {
                const: '642421'
              }
            }
          }, {
            oneOf: [{
              properties: {
                dty_start: {
                  multipleOf: 4,
                  not: {
                    multipleOf: 100
                  }
                }
              }
            }, {
              properties: {
                dty_start: {
                  multipleOf: 400
                }
              }
            }]
          }]
        },
        then: {
          properties: {
            dtd_start: {
              maximum: 29
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_start: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_start: {
                not: {
                  multipleOf: 4
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_start: {
              maximum: 28
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_start: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_start: {
                multipleOf: 100,
                not: {
                  multipleOf: 400
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_start: {
              maximum: 28
            }
          }
        }
      }]
    }, {
      allOf: [{
        if: {
          properties: {
            dtm_end: {
              enum: ['642423', '642425', '642428', '642430']
            }
          }
        },
        then: {
          properties: {
            dtd_end: {
              maximum: 30
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_end: {
                const: '642421'
              }
            }
          }, {
            oneOf: [{
              properties: {
                dty_end: {
                  multipleOf: 4,
                  not: {
                    multipleOf: 100
                  }
                }
              }
            }, {
              properties: {
                dty_end: {
                  multipleOf: 400
                }
              }
            }]
          }]
        },
        then: {
          properties: {
            dtd_end: {
              maximum: 29
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_end: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_end: {
                not: {
                  multipleOf: 4
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_end: {
              maximum: 28
            }
          }
        }
      }, {
        if: {
          allOf: [{
            properties: {
              dtm_end: {
                const: '642421'
              }
            }
          }, {
            properties: {
              dty_end: {
                multipleOf: 100,
                not: {
                  multipleOf: 400
                }
              }
            }
          }]
        },
        then: {
          properties: {
            dtd_end: {
              maximum: 28
            }
          }
        }
      }]
    }]
  },
  uiSchema: {
    '643171': {
      'ui:title': {
        text: 'Expected Date of Submission for Funding',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        compact: true
      }
    },
    dtm_expsub: {
      'ui:title': {
        text: 'Month',
        escape: true
      },
      'ui:widget': 'select'
    },
    dtd_expsub: {
      'ui:title': {
        text: 'Day',
        escape: true
      },
      'ui:widget': 'text'
    },
    '643174': {
      'ui:title': {
        text: ',',
        escape: true
      },
      'ui:widget': 'text'
    },
    dty_expsub: {
      'ui:title': {
        text: 'Year',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    },
    '643176': {
      'ui:title': {
        text: 'Date Submitted for Funding',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        compact: true
      }
    },
    dtm_sub: {
      'ui:title': {
        text: 'Month',
        escape: true
      },
      'ui:widget': 'select'
    },
    dtd_sub: {
      'ui:title': {
        text: 'Day',
        escape: true
      },
      'ui:widget': 'text'
    },
    '643179': {
      'ui:title': {
        text: ',',
        escape: true
      },
      'ui:widget': 'text'
    },
    dty_sub: {
      'ui:title': {
        text: 'Year',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    },
    '643182': {
      'ui:title': {
        text: 'Start Date of Funding',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        compact: true
      }
    },
    dtm_start: {
      'ui:title': {
        text: 'Month',
        escape: true
      },
      'ui:widget': 'select'
    },
    dtd_start: {
      'ui:title': {
        text: 'Day',
        escape: true
      },
      'ui:widget': 'text'
    },
    '643185': {
      'ui:title': {
        text: ',',
        escape: true
      },
      'ui:widget': 'text'
    },
    dty_start: {
      'ui:title': {
        text: 'Year',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    },
    '643187': {
      'ui:title': {
        text: 'End Date of Funding',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        compact: true
      }
    },
    dtm_end: {
      'ui:title': {
        text: 'Month',
        escape: true
      },
      'ui:widget': 'select'
    },
    dtd_end: {
      'ui:title': {
        text: 'Day',
        escape: true
      },
      'ui:widget': 'text'
    },
    '643190': {
      'ui:title': {
        text: ',',
        escape: true
      },
      'ui:widget': 'text'
    },
    dty_end: {
      'ui:title': {
        text: 'Year',
        escape: true
      },
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    },
    'dm:layout': [{
      id: '643171',
      type: 'group',
      orientation: 'horizontal',
      children: [{
        id: 'dtm_expsub',
        type: 'field'
      }, {
        id: 'dtd_expsub',
        type: 'field'
      }, {
        id: '643174',
        type: 'text'
      }, {
        id: 'dty_expsub',
        type: 'field'
      }]
    }, {
      id: '643176',
      type: 'group',
      orientation: 'horizontal',
      children: [{
        id: 'dtm_sub',
        type: 'field'
      }, {
        id: 'dtd_sub',
        type: 'field'
      }, {
        id: '643179',
        type: 'text'
      }, {
        id: 'dty_sub',
        type: 'field'
      }]
    }, {
      id: '643182',
      type: 'group',
      orientation: 'horizontal',
      children: [{
        id: 'dtm_start',
        type: 'field'
      }, {
        id: 'dtd_start',
        type: 'field'
      }, {
        id: '643185',
        type: 'text'
      }, {
        id: 'dty_start',
        type: 'field'
      }]
    }, {
      id: '643187',
      type: 'group',
      orientation: 'horizontal',
      children: [{
        id: 'dtm_end',
        type: 'field'
      }, {
        id: 'dtd_end',
        type: 'field'
      }, {
        id: '643190',
        type: 'text'
      }, {
        id: 'dty_end',
        type: 'field'
      }]
    }]
  },
  formData: {}
};